import { useState, useEffect } from "react";
import React from "react";
import { getFirestore, getDocs, getDoc, doc, collection } from "firebase/firestore";
import app from "./firebase";
import { useCookies } from "react-cookie";
import { Helmet } from "react-helmet";
import {
  LogOut, Menu, X, ChevronRight, Sprout, Package, ShoppingCart, BookOpen,
  LayoutDashboard, History as HistoryIcon, Wallet, Settings, PhoneCall, Leaf
} from "lucide-react";

const db = getFirestore(app);

const History = () => {
  const [name, setName] = useState("Investor");
  const [wallet, setWallet] = useState("0.00");
  const [farm_invested_data, setFarmInvestedData] = useState([]);
  const [no_sold, setNoSold] = useState(0);
  const [show_mobile_menu, setMobileMenu] = useState(false);
  const [cookies, , removeCookie] = useCookies(["name"]);

  const userId = cookies.username;
  if (userId == undefined) window.location.href = "/login";

  useEffect(() => {
    if (show_mobile_menu) document.body.classList.add("lock-scroll");
    else document.body.classList.remove("lock-scroll");
    return () => document.body.classList.remove("lock-scroll");
  }, [show_mobile_menu]);

  useEffect(() => {
    const initiateData = async () => {
      try {
        const docRef = doc(db, "users", userId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const ud = { id: docSnap.id, ...docSnap.data() };
          setName(ud.name);
          setWallet((ud.wallet).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,"));
        }
        const querySnapshot = await getDocs(collection(db, "investment"));
        const data = querySnapshot.docs.map(d => ({ ...d.data(), id: d.id }));
        const sold = data.filter(el => el.owner === userId && el.investment_status !== " active");
        setFarmInvestedData(data);
        setNoSold(sold.length);
      } catch (error) { console.error(error); }
    };
    initiateData();
  }, []);

  const holdingDays = (date2) => {
    const parts = date2.split("/");
    const formattedDate2 = `${parts[2]}-${parts[1]}-${parts[0]}`;
    const current_date = new Date().setHours(0, 0, 0, 0);
    const date_2 = new Date(formattedDate2).setHours(0, 0, 0, 0);
    return Math.floor((current_date - date_2) / (1000 * 60 * 60 * 24));
  };

  const soldItems = farm_invested_data.filter(i => i.owner === userId && i.investment_status !== " active");

  const navItems = [
    { icon: <LayoutDashboard size={18} />, label: "Dashboard", action: () => { window.location.href = "/dashboard"; } },
    { icon: <HistoryIcon size={18} />, label: "Investment History", action: null, active: true },
    { icon: <Wallet size={18} />, label: "Wallet", action: () => { window.location.href = "/wallet"; } },
    { icon: <Settings size={18} />, label: "Settings", action: () => { window.location.href = "/settings"; } },
    { icon: <ShoppingCart size={18} />, label: "Marketplace", action: () => { window.location.href = "/market_dashboard"; } },
    { icon: <BookOpen size={18} />, label: "Health & News (Blog)", action: () => { window.location.href = "/blog"; } },
    { icon: <PhoneCall size={18} />, label: "Contact Support", action: () => { window.location.href = "/contact"; } },
  ];

  return (
    <div style={{ fontFamily: "var(--font-sans)", display: "flex", minHeight: "100vh", background: "var(--color-gray-50)" }}>
      <Helmet><title>Investment History — Agrivestia</title></Helmet>

      {show_mobile_menu && <div className="overlay" onClick={() => setMobileMenu(false)} />}

      {/* Sidebar */}
      <aside className={`sidebar ${show_mobile_menu ? "open" : ""}`} style={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" }}>
        <div style={{ padding: "24px 20px 16px", borderBottom: "1px solid var(--color-gray-100)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "20px" }}>
            <div style={{ width: "34px", height: "34px", borderRadius: "10px", background: "var(--gradient-accent)", display: "flex", alignItems: "center", justifyContent: "center" }}><Leaf size={17} color="white" /></div>
            <span style={{ fontWeight: 800, fontSize: "17px", color: "var(--color-primary-dark)", letterSpacing: "-0.02em" }}>AGRIVESTIA</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{ width: "36px", height: "36px", borderRadius: "50%", background: "var(--gradient-primary)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: "15px", color: "white" }}>{name ? name[0].toUpperCase() : "U"}</div>
            <div><div style={{ fontWeight: 600, fontSize: "13px", color: "var(--color-gray-800)" }}>{name}</div><div style={{ fontSize: "11px", color: "var(--color-gray-400)" }}>Agrivestia Farmer</div></div>
          </div>
        </div>
        <div style={{ margin: "16px", padding: "14px 16px", background: "var(--color-primary-light)", borderRadius: "var(--radius-md)", border: "1px solid var(--color-accent-light)" }}>
          <div style={{ fontSize: "11px", fontWeight: 600, color: "var(--color-primary)", letterSpacing: "0.05em", marginBottom: "4px" }}>WALLET BALANCE</div>
          <div style={{ fontSize: "20px", fontWeight: 800, color: "var(--color-primary-dark)" }}>₦{wallet}</div>
        </div>
        <nav style={{ padding: "0 12px", flex: 1, overflowY: "auto" }}>
          <div style={{ fontSize: "11px", fontWeight: 700, color: "var(--color-gray-400)", letterSpacing: "0.07em", textTransform: "uppercase", padding: "4px 8px 10px" }}>Menu</div>
          {navItems.map((item, i) => (
            <button key={i} onClick={item.action ? () => { setMobileMenu(false); item.action(); } : undefined}
              className={`sidebar-link ${item.active ? "active" : ""}`} style={{ width: "100%", border: "none", cursor: "pointer", marginBottom: "2px" }}>
              <span>{item.icon}</span><span style={{ fontSize: "14px" }}>{item.label}</span>
              {item.active && <ChevronRight size={14} style={{ marginLeft: "auto" }} />}
            </button>
          ))}
        </nav>
        <div style={{ padding: "12px 12px 20px", borderTop: "1px solid var(--color-gray-100)" }}>
          <button className="sidebar-link danger" onClick={() => { removeCookie("username"); window.location.href = "/login"; }} style={{ width: "100%", border: "none", cursor: "pointer" }}>
            <LogOut size={17} /><span style={{ fontSize: "14px" }}>Log Out</span>
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="main-content">
        <div style={{ background: "var(--color-white)", borderBottom: "1px solid var(--color-gray-100)", padding: "0 16px", minHeight: "64px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
          {/* Mobile Menu & Logo (Left) */}
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {/* Mobile hamburger */}
            <button onClick={() => setMobileMenu(!show_mobile_menu)}
              style={{ background: "none", border: "none", cursor: "pointer", color: "var(--color-gray-600)", display: "none", padding: "4px" }}
              className="show-mobile">
              {show_mobile_menu ? <X size={24} /> : <Menu size={24} />}
            </button>

            <div className="show-mobile" style={{ display: "none", alignItems: "center", gap: "8px" }}
              onClick={() => window.location.href = "/"}>
              <div style={{ width: "30px", height: "30px", borderRadius: "8px", background: "var(--gradient-accent)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Leaf size={15} color="white" />
              </div>
              <span style={{ fontWeight: 800, fontSize: "14px", color: "var(--color-primary-dark)", letterSpacing: "-0.02em" }}>AGRIVESTIA</span>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <div className="hide-mobile">
              <div style={{ fontSize: "16px", fontWeight: 700, color: "var(--color-gray-900)" }}>Investment History</div>
              <div style={{ fontSize: "12px", color: "var(--color-gray-400)" }}>{no_sold} past transaction(s)</div>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {/* Empty space to balance flex if needed */}
          </div>
        </div>

        <div style={{ padding: "clamp(16px, 5vw, 28px)" }}>
          <div className="card" style={{ padding: 0 }}>
            <div style={{ padding: "20px 24px", borderBottom: "1px solid var(--color-gray-100)", display: "flex", alignItems: "center", gap: "8px" }}>
              <Package size={16} color="var(--color-primary)" />
              <div style={{ fontWeight: 700, fontSize: "15px", color: "var(--color-gray-800)" }}>Past Transactions</div>
            </div>

            {/* Desktop table */}
            <div className="hide-mobile" style={{ overflowX: "auto" }}>
              {soldItems.length === 0 ? (
                <div style={{ textAlign: "center", padding: "60px 24px", color: "var(--color-gray-400)" }}>
                  <Sprout size={36} color="var(--color-gray-300)" style={{ margin: "0 auto 12px" }} />
                  <div style={{ fontWeight: 600, fontSize: "14px", marginBottom: "6px" }}>No history yet</div>
                  <div style={{ fontSize: "13px" }}>Once you sell investments, they'll appear here</div>
                </div>
              ) : (
                <table className="data-table">
                  <thead>
                    <tr><th>S/N</th><th>Name</th><th>Category</th><th>Value</th><th>Qty</th><th>Holding Days</th><th>Status</th></tr>
                  </thead>
                  <tbody>
                    {soldItems.map((item, i) => (
                      <tr key={item.id}>
                        <td style={{ color: "var(--color-gray-400)", fontSize: "13px", fontWeight: 600 }}>{i + 1}</td>
                        <td>
                          <div style={{ fontWeight: 600, fontSize: "14px", color: "var(--color-gray-800)" }}>{item.name}</div>
                          <div style={{ fontSize: "12px", color: "var(--color-gray-400)" }}>{item.measurment}</div>
                        </td>
                        <td style={{ fontSize: "13px" }}>{item.category}</td>
                        <td><span style={{ fontWeight: 600, color: "var(--color-primary-dark)" }}>₦{item.price}</span></td>
                        <td><span className="badge badge-neutral">{item.quantity}</span></td>
                        <td><span className="badge badge-primary">{holdingDays(item.date)} day(s)</span></td>
                        <td><span className="badge badge-danger">Sold</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {/* Mobile cards */}
            <div className="show-mobile" style={{ padding: "16px", flexDirection: "column", gap: "12px", display: "none", overflowY: "auto", width: "100%" }}>
              {soldItems.length === 0 ? (
                <div style={{ textAlign: "center", padding: "40px 0", color: "var(--color-gray-400)", width: "100%" }}>
                  <div style={{ fontSize: "14px", fontWeight: 600 }}>No history yet</div>
                </div>
              ) : soldItems.map((item, i) => (
                <div key={item.id} className="card-stack-item">
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px", alignItems: "center" }}>
                    <div style={{ fontWeight: 700, fontSize: "15px", color: "var(--color-gray-800)" }}>{item.name}</div>
                    <span className="badge badge-danger">Sold</span>
                  </div>
                  <div className="card-stack-row"><span className="card-stack-label">Category</span><span className="card-stack-value">{item.category}</span></div>
                  <div className="card-stack-row"><span className="card-stack-label">Value</span><span className="card-stack-value">₦{item.price}</span></div>
                  <div className="card-stack-row"><span className="card-stack-label">Qty</span><span className="card-stack-value">{item.quantity}</span></div>
                  <div className="card-stack-row" style={{ borderBottom: "none" }}><span className="card-stack-label">Holding</span><span className="card-stack-value">{holdingDays(item.date)} days</span></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      <style>{`
      `}</style>
    </div>
  );
};

export default History;
